/**
 * Starts the app again from a page, as a fresh load. Used when the Admin starts or ends "view as a user": nothing on
 * screen, in a component's state or in a cache may be left over from the other person's view. Its own module so a test
 * can stand in for the navigation.
 */
export const restartApp = (to = '/home') => {
  window.location.assign(to);
};
